import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BaseCellComponent} from '../_base-cell/base-cell.component';

@Component({
    selector: 'motn-sort-table-cell-empty',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./sort-table-cell-empty.component.scss'],
})
export class SortTableCellEmptyComponent extends BaseCellComponent implements OnInit {

  constructor() {
    super();
  }


  protected onInit(): void {
  }

}
